import get from 'lodash/get';
import config from '../config';
import MediaAPI from './api/mediaAPI';

import { MEDIA_SIZES } from './constants/mediaService';

const getSquareImageUrl = (imageId, fileType) => {
  const fileExt = fileType ? `.${fileType}` : '';
  return `${config.mediaServiceUrl}/images/${imageId}/${MEDIA_SIZES.SQUARE}${fileExt}`;
};

const getMediumImageUrl = (imageId, fileType) => {
  const fileExt = fileType ? `.${fileType}` : '';
  return `${config.mediaServiceUrl}/images/${imageId}/${MEDIA_SIZES.MEDIUM}${fileExt}`;
};

const getThumbnailImageUrl = (imageId, fileType) => {
  const fileExt = fileType ? `.${fileType}` : '';
  return `${config.mediaServiceUrl}/images/${imageId}/${MEDIA_SIZES.THUMBNAIL}${fileExt}`;
};

const getLargeImageUrl = (imageId, fileType) => {
  const fileExt = fileType ? `.${fileType}` : '';
  return `${config.mediaServiceUrl}/images/${imageId}/${MEDIA_SIZES.LARGE}${fileExt}`;
};

const getBannerImageUrl = (imageId, fileType) => {
  const fileExt = fileType ? `.${fileType}` : '';
  return `${config.mediaServiceUrl}/images/${imageId}/${MEDIA_SIZES.BANNER}${fileExt}`;
};

const getCustomImageUrl = (imageId, width, height, fileType) => {
  const fileExt = fileType ? `.${fileType}` : '';
  return `${config.mediaServiceUrl}/images/${imageId}/w${width}_h${height}${fileExt}`;
};

const getSmallLogoUrl = (imageId, fileType) => {
  const fileExt = fileType ? `.${fileType}` : '';
  return `${config.mediaServiceUrl}/images/${imageId}/${MEDIA_SIZES.SMALL_LOGO}${fileExt}`;
};

const getOriginalImageUrl = (imageId, fileType) => {
  const fileExt = fileType ? `.${fileType}` : '';
  return `${config.mediaServiceUrl}/images/${imageId}/${MEDIA_SIZES.ORIGINAL}${fileExt}`;
};

const getMediaUrl = (id, mediaType, options = {}) => {
  const { width = 0, height = 0, fileType } = options;
  switch (mediaType) {
    case MEDIA_SIZES.SMALL_LOGO:
      return getSmallLogoUrl(id, fileType);
    case MEDIA_SIZES.SQUARE:
      return getSquareImageUrl(id, fileType);
    case MEDIA_SIZES.MEDIUM:
      return getMediumImageUrl(id, fileType);
    case MEDIA_SIZES.THUMBNAIL:
      return getThumbnailImageUrl(id, fileType);
    case MEDIA_SIZES.LARGE:
      return getLargeImageUrl(id, fileType);
    case MEDIA_SIZES.ORIGINAL:
      return getOriginalImageUrl(id, fileType);
    case MEDIA_SIZES.BANNER:
      return getBannerImageUrl(id, fileType);
    case MEDIA_SIZES.CUSTOM:
      if (width === 0 || height === 0) return null;
      return getCustomImageUrl(id, width, height, fileType);
    default:
      return '';
  }
};

const uploadImages = async (imageBlobs, entityType) => {
  if (imageBlobs.length < 1) {
    return [];
  }
  let promises = imageBlobs.map(media => fetch(media.url));
  const images = await Promise.all(promises);
  promises = images.map(image => image.blob());
  const files = await Promise.all(promises);
  promises = files.map((file, i) => {
    const formData = new FormData();
    formData.append('file', file, imageBlobs[i].filename);
    const query = { entity_type: entityType };
    return MediaAPI.createEntity(formData, query);
  });
  const responses = await Promise.all(promises);
  return responses.map(response => get(response, 'data.id'));
};

const deleteImages = async (ids) => {
  if (ids.length < 1) {
    return [];
  }
  const promises = ids.map(id => MediaAPI.destroyEntity(id));
  const entities = await Promise.all(promises);
  return entities;
};

const getMediaIdFromURL = (url) => {
  const URLItems = url?.split('/') || [];
  return URLItems[URLItems.length - 2] || '';
};

export {
  getSquareImageUrl,
  getMediumImageUrl,
  getThumbnailImageUrl,
  getLargeImageUrl,
  getMediaUrl,
  uploadImages,
  getBannerImageUrl,
  deleteImages,
  getMediaIdFromURL,
};

export default {
  getSquareImageUrl,
  getMediumImageUrl,
  getThumbnailImageUrl,
  getLargeImageUrl,
  getMediaUrl,
  uploadImages,
  getBannerImageUrl,
  deleteImages,
  getMediaIdFromURL,
};
